import { ReservationUIContext } from "@/providers/ReservationUIProvider/ReservationUIContext";
import { useContext } from "react";

export default function useReservationUI() {
  const context = useContext(ReservationUIContext);
  if (!context)
    throw new Error(
      "ReservationUIContext must be used within a ReservationUIProvider",
    );

  return context;
}
